import React from "react";
import Slider from "react-slick";

import shape1 from "../../images/testimonial/img-1.jpg";
import shape2 from "../../images/testimonial/img-2.jpg";

// ✅ Define TypeScript interface for testimonial items
interface TestimonialItem {
  id: string;
  Des: string;
  Title: string;
  Date: string;
}

// ✅ Testimonials data
const testimonials: TestimonialItem[] = [
  {
    id: "01",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Marlin & Williamson",
    Date: "23.05.2025",
  },
  {
    id: "02",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Rihanna & William",
    Date: "08.12.2025",
  },
  {
    id: "03",
    Des: "Planning a wedding felt overwhelming until we met Bohu. Their team took our ideas and transformed them into a celebration beyond what we could have imagined. Truly professional, creative, and supportive throughout the journey.",
    Title: "Sarah & Daniel",
    Date: "12.08.2025",
  },
];

// ✅ Functional component
const Testimonial: React.FC = () => {
  const settings = {
    dots: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <section className="wpo-testimonial-section section-padding">
      <div className="container-fluid">
        <div className="wpo-testimonial-wrap">
          <div className="row justify-content-center">
            <div
              className="col col-xl-8 col-lg-8 col-12 wow fadeInUp"
              data-wow-duration="1700ms"
            >
              <div className="wpo-testimonial-items">
                <div className="wpo-testimonial-active">
                  <Slider {...settings}>
                    {testimonials.map((item) => (
                      <div className="wpo-testimonial-item" key={item.id}>
                        <div className="wpo-testimonial-text">
                          <i className="ti-quote-right"></i>
                          <p>"{item.Des}"</p>
                          <div className="wpo-testimonial-text-btm">
                            <h3>{item.Title}</h3>
                            <span>Wedding - {item.Date}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Images */}
      <div
        className="image-1 image-move wow zoomIn"
        data-wow-duration="1200ms"
      >
        <img src={shape1} alt="decorative testimonial background" />
      </div>
      <div
        className="image-2 image-move wow zoomIn"
        data-wow-duration="1200ms"
      >
        <img src={shape2} alt="decorative testimonial background" />
      </div>
    </section>
  );
};

export default Testimonial;
